<template>
    <el-dialog
            title="赠送优惠券"
            :visible.sync="visible"
            width="40%"
            center>


        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>选择发放优惠券</span>
            </div>
            <div class="text item">
                <el-form :inline="true" :model="query" class="demo-form-inline" size="small">
                    <el-form-item label="关键字">
                        <el-input clearable placeholder="设备编号/设备名称" v-model="query.keyword"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitQuery(1)" size="small" icon="el-icon-search">搜索
                        </el-button>
                    </el-form-item>
                </el-form>
                <el-table
                        border
                        v-loading="deviceLoading"
                        ref="singleTable"
                        :data="devices"
                        highlight-current-row
                        @current-change="handleCurrentChange"
                        style="width: 100%">
                    <el-table-column align="center" label="优惠券名称" prop="name"/>
                    <el-table-column align="center" label="描述">
                        <template slot-scope="scope">
                            {{scope.row.remark}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="使用规则">
                        <template slot-scope="scope">
                            <span>满{{scope.row.miniPayMoney}}减{{scope.row.offsetMoney}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <vue-pager v-bind:datafile="fillData" :limit="5" url="coupon/pageCoupon" v-bind:query="query"
                           ref="devicePager"
                           v-bind:init="true"></vue-pager>
            </div>
        </el-card>

        <span slot="footer" class="dialog-footer">
                    <el-button @click="visible=false">取 消</el-button>
                    <el-button type="primary" @click="saveOrderSend">确 定</el-button>
                </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "order-send",
        data: function () {
            return {
                deviceLoading: false,
                devices: [],
                currentRow: {},
                visible: false,
                query: {
                    limit: 5,
                    status: 'ENABLE',
                    channel: 'ADMIN',
                    keyword: ''
                },
                printerCurrentRow: {},

            }
        },
        props: {},
        methods: {
            submitQuery(_num) {
                this.devices = [];
                if (this.$refs.devicePager) {
                    this.$refs.devicePager.gotoPage(_num);
                }
            },
            fillData(response) {
                this.devices = response.items || [];
                this.deviceLoading = false
            },
            handleCurrentChange(val) {
                this.currentRow = val;
            },
            saveOrderSend() {
                if (!this.currentRow.id) {
                    this.$message.error("请选择优惠券")
                    return
                }
                if (!this.userId) {
                    this.$message.error("请选择用户")
                    return
                }

                this.$common.my_ajax({
                    url: '/couponMember/saveCouponMember',
                    data: {
                        "couponId": this.currentRow.id,
                        "userId": this.userId
                    },
                    success: () => {
                        this.$message.success("已发放")
                        this.visible = false;
                    }
                });
            },
            open(e) {
                let {userId} = e;
                if (userId) {
                    this.visible = true;
                    this.userId = userId
                } else {
                    this.$message.error("订单异常");
                }
            },

        },
        watch: {
            visible: function (val, oldVal) {
                if (val === true) {
                    if (this.$refs.devicePager) {
                        this.deviceLoading = true;
                        this.$refs.devicePager.gotoPage(1);
                    }
                } else {
                    Object.assign(this.$data, this.$options.data())
                }
            },
            orderId: function (val, oldVal) {
                console.log(val);
            }
        }
    }
</script>

<style scoped>
    .box-card {
        margin-top: 20px;
    }
</style>
